/**
 * Hostname de PRODUÇÃO, comparado por igualdade. Já foi
 * `!location.hostname.includes('localhost')`, o que só excluía a máquina do
 * dev: `app-staging.vibx.com.br` passava, e tudo que o staging faz — teste
 * manual, fluxo pela metade, robô de e2e — entrava na medição junto com o
 * tráfego real.
 *
 * Isso deixou de ser detalhe quando o GA4 passou a ser o mesmo do vibx.com.br
 * (ver `utils/googleAnalytics.ts`): o lixo do staging não sujaria só os números
 * deste app, sujaria o funil do site inteiro.
 *
 * Uma variável de ambiente não resolveria: o `.env.local` é versionado e vale
 * para os dois builds, e um `NEXT_PUBLIC_*` do `.env` não tem como
 * sobrescrevê-lo. O domínio é a única coisa que de fato separa os dois
 * ambientes em runtime.
 */
const PROD_HOSTNAME = 'app.vibx.com.br';

export const isProdClient = () => location.hostname === PROD_HOSTNAME;
